import { ColorEnum } from '@/constants/color'
import PriceItem from '@/features/common/components/Overview/parts/Prices/parts/PriceItem'
import TotalPrice from '@/features/common/components/Overview/parts/Prices/parts/TotalPrice'
import { PriceItem as PriceItemType } from '@/features/common/components/Overview/types'
import Typography from '@/features/ui/typography'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { StyleSheet, View } from 'react-native'

export interface PricesProps {
    items: PriceItemType[]
    totalPrice: string
}

const Prices: FC<PricesProps> = ({ items, totalPrice }) => {
    const { t } = useTranslation()

    return (
        <View style={styles.container}>
            <Typography.Heading variant="h3" style={styles.heading}>
                {t('common.overview.summary')}
            </Typography.Heading>
            <View style={styles.items}>
                {items.map((item, index) => (
                    <PriceItem
                        key={`${item.label}-${index}`}
                        label={item.label}
                        price={item.price}
                    />
                ))}
            </View>
            <TotalPrice price={totalPrice} />
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        padding: 16,
        gap: 10,
        overflow: 'hidden',
        borderWidth: 1,
        borderColor: ColorEnum.GRAY_200,
        borderRadius: 8,
        backgroundColor: ColorEnum.GRAY_100,
    },
    heading: {
        color: ColorEnum.GRAY_900,
    },
    items: {
        gap: 8,
    },
})

export default Prices
